import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { addUserRole } from '../redux/features/user/usersSlice';
import { APP_PATH_DASHBOARD, APP_PATH_MY_APPLICATIONS } from '../config';

export const useUserTypeSelection = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const selectCompany = useCallback(async () => {
    setIsLoading(true);
    try {
      dispatch(addUserRole('ROLE_COMPANY'));
      history.push(APP_PATH_DASHBOARD);
    } catch (error) {
      console.error('Failed to set company role:', error);
      // Error message is already handled by the thunk
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, history]);

  const selectCandidate = useCallback(async () => {
    setIsLoading(true);
    try {
      dispatch(addUserRole('ROLE_CANDIDATE'));
      history.push(APP_PATH_MY_APPLICATIONS); // Redirect candidates to My Applications
    } catch (error) {
      console.error('Failed to set candidate role:', error);
      // Error message is already handled by the thunk
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, history]);

  return {
    selectCompany,
    selectCandidate,
    isLoading
  };
};
